<template>
  <div class="config-boolean" :style="wrapperStyle">
    <label>
      <span>Yes</span>
      <input
        :checked="value === true"
        type="radio"
        :name="name"
        @change="$emit('input', true)"
      />
    </label>
    <label>
      <span>No</span>
      <input
        :checked="value === false"
        type="radio"
        :name="name"
        @change="$emit('input', false)"
      />
    </label>
  </div>
</template>

<script>
export default {
  name: 'ConfigBooleanElement',
  props: {
    value: {
      type: Boolean,
      default: null
    },
    name: {
      type: String,
      default: 'config-boolean'
    },
    defaultStyle: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    wrapperStyle () {
      return {
        borderColor: this.defaultStyle.borderColor,
        backgroundColor: this.defaultStyle.backGroundColor
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.config-boolean {
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: 30px;
  padding: 0 10px;
  border: 1px solid #dfe5ed;
  border-radius: 4px;
  background: #ffffff;

  label {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    color: #344054;
    font-size: var(--text-xs2);
  }

  input {
    width: 14px;
    height: 14px;
    margin: 0;
  }
}
</style>
